module.exports = __webpack_public_path__ + "img/3.1f48ec52.png";